// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1BvdN","item":"style_item__3n5Zf","number":"style_number__2CJjC","label":"style_label__1fpbJ","img":"style_img__31_XP","allbtn":"style_allbtn__3LYYL"};